import { ViewMode, ViewModeEnum } from '../types/viewMode';

/**
 * Maps the URL pathname → the in-app ViewMode that Home.tsx renders.
 * Anything unrecognised falls back to Dashboard so /, /unknown, etc.
 * all land somewhere sensible.
 */
export const pathToView = (pathname: string): ViewMode => {
  switch (pathname) {
    case '/posts': return ViewModeEnum.Grid;
    case '/schedule': return ViewModeEnum.Schedule;
    case '/attendance': return ViewModeEnum.Attendance;
    case '/attendance-stats': return ViewModeEnum.AttendanceStats;
    case '/insights': return ViewModeEnum.Insights;
    case '/reports': return ViewModeEnum.Report;
    case '/documents': return ViewModeEnum.Documents;
    default: return ViewModeEnum.Dashboard;
  }
};

export const viewToPath = (mode: ViewMode): string => {
  switch (mode) {
    case ViewModeEnum.Grid: return '/posts';
    case ViewModeEnum.Schedule: return '/schedule';
    case ViewModeEnum.Attendance: return '/attendance';
    case ViewModeEnum.AttendanceStats: return '/attendance-stats';
    case ViewModeEnum.Insights: return '/insights';
    case ViewModeEnum.Report: return '/reports';
    case ViewModeEnum.Documents: return '/documents';
    default: return '/';
  }
};
